import React, { useMemo, useRef } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { SearchBar } from '@fiverr-private/search_bar';
import { translate } from '@fiverr-private/i18n-react';
import { usePlaceholderFade } from '../../shared/placeholderFade';
import { SEARCH_INPUT_SELECTOR } from './constants';

interface Props {
    placeholderKey: string;
    phraseKeys: string[];
    source: string;
    theme?: string;
    submitButtonType?: string;
    hideClearButton?: boolean;
    onFocus?: () => void;
    onSearch?: (query: string) => void;
    searchWillSubmit?: () => boolean;
}

const AnimatedSearchBar = ({ placeholderKey, phraseKeys, onFocus, ...searchBarProps }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const placeholder = translate(placeholderKey) as string;
    const phrases = useMemo(() => phraseKeys.map((key) => translate(key) as string), [phraseKeys]);

    usePlaceholderFade(containerRef, phrases, {
        staticText: placeholder,
        selector: SEARCH_INPUT_SELECTOR,
    });

    return (
        <Container ref={containerRef} width="100%" maxWidth="100%" onFocus={onFocus}>
            <SearchBar placeholder={placeholder} {...searchBarProps} />
        </Container>
    );
};

export default AnimatedSearchBar;
